import { FeatureFlag } from '../FeatureFlag';

export const enableGlobalAssistant = new FeatureFlag({
    key: 'enable-global-assistant',
    createdOn: '2026-04-19',
    defaultValue: false,
});
